<div style="text-align: right; margin-top: -1.063rem; margin-right: -0.813rem">
  <span (click)="closeDialog()" class="closeButton">&#10005;</span>
</div>
<div>
  <div style="display: inline-block; width: 5.5rem">
    <span class="headerText">Status</span>
  </div>
  <div
    style="
      display: inline-block;
      width: 4.8rem;
      text-align: center;
      line-height: 1rem;
      margin-right: 0.625rem;
    "
  >
    <span class="headerText">Charging Project ID</span>
  </div>
  <div style="display: inline-block; width: 8.113rem">
    <span class="headerText">Project Type</span>
  </div>
  <div style="display: inline-block; width: 10.925rem">
    <span class="headerText">Project Name</span>
  </div>
  <div style="display: inline-block; width: 9.738rem">
    <span class="headerText">Major Location</span>
  </div>
  <div style="display: inline-block; width: 7.456rem">
    <div style="width: 5.875rem; text-align: center; line-height: 1rem">
      <span class="headerText">Project Charge Indicator</span>
    </div>
  </div>
  <div style="display: inline-block; width: 10.988rem">
    <span class="headerText">Asset Location</span>
  </div>
  <div style="display: inline-block; width: 3.8rem">
    <div style="width: 2.625rem; text-align: center; line-height: 1rem">
      <span class="headerText">Resp. Center</span>
    </div>
  </div>
  <div style="display: inline-block; width: 6.425rem">
    <div style="width: 3.375rem; text-align: center; line-height: 1rem">
      <span class="headerText">Contract Admin.</span>
    </div>
  </div>
  <div style="display: inline-block">
    <span class="headerText">Activity ID</span>
  </div>
</div>
<div style="border-bottom: 0.063rem solid #696969; padding-top: 0.2rem; width: 100%"></div>
@for (project of data; track project; let i = $index) {
  <div>
    <div
      style="padding-top: 0.938rem; padding-bottom: 0.938rem"
      [class.inProcessOption]="project.status === 'MMAPS In Process'"
    >
      <div style="display: inline-block; width: 5.5rem; line-height: 1.1rem; vertical-align: top">
        <span class="bodyText" [class.inProcessFont]="project.status === 'MMAPS In Process'">{{
          project.status
        }}</span>
      </div>
      <div
        style="
          display: inline-block;
          width: 4.8rem;
          text-align: center;
          line-height: 1.1rem;
          vertical-align: top;
          margin-right: 0.625rem;
        "
      >
        <span class="bodyText">{{ project.chargingProjectID }}</span>
      </div>
      <div
        style="
          display: inline-block;
          width: 6.863rem;
          line-height: 1.1rem;
          vertical-align: top;
          margin-right: 1.25rem;
        "
      >
        <span class="bodyText">{{ project.projectType }}</span>
      </div>
      <div
        style="
          display: inline-block;
          width: 9.675rem;
          line-height: 1.1rem;
          vertical-align: top;
          margin-right: 1.25rem;
        "
      >
        <span class="bodyText">{{ project.projectName }}</span>
      </div>
      <div
        style="
          display: inline-block;
          width: 8.488rem;
          line-height: 1.1rem;
          vertical-align: top;
          margin-right: 1.25rem;
        "
      >
        <span class="bodyText">{{ project.majorLocation }}</span>
      </div>
      <div
        style="
          display: inline-block;
          width: 6.206rem;
          line-height: 1.1rem;
          vertical-align: top;
          margin-right: 1.25rem;
        "
      >
        <span class="bodyText">{{ project.projectChargeIndicator }}</span>
      </div>
      <div
        style="
          display: inline-block;
          width: 9.738rem;
          line-height: 1.1rem;
          vertical-align: top;
          margin-right: 1.25rem;
        "
      >
        <span class="bodyText">{{ project.assetLocation }}</span>
      </div>
      <div style="display: inline-block; width: 3.8rem; line-height: 1.1rem; vertical-align: top">
        <span class="bodyText">{{ project.respCenter }}</span>
      </div>
      <div
        style="
          display: inline-block;
          width: 5.175rem;
          line-height: 1.1rem;
          vertical-align: top;
          margin-right: 1.25rem;
        "
      >
        <span class="bodyText">{{ project.contractAdmin }}</span>
      </div>
      <div style="display: inline-block; line-height: 1.1rem; vertical-align: top">
        @for (id of project.activityIDs; track id) {
          <div>
            <span class="bodyText">{{ id }}</span>
          </div>
        }
      </div>
    </div>
    <div style="border-bottom: 0.063rem solid #c9c9c9; width: 100%"></div>
  </div>
}
